import { http } from '@/utils/plugins/http'

export const getMatchingProducts = (ids) => http.post(`products/get_matched_products`, { ids })
export const getEbayMatchingProducts = (ids) => http.post(`products/get_ebay_matched_products`, { ids })
